import { action } from 'satcheljs';

export let showTodoPanelWithSubject = action(
    'showTodoPanelWithSubject',
    (subject: string, messageId?: string, extractionId?: string) => ({
        subject,
        messageId,
        extractionId,
    })
);
